import React from "react";
import {Button, Col, Divider, Image, Input, Row, Table, DeleteButton} from "@pankod/refine-antd";
import {Product} from "../../../Interfaces";
import {PublishedProductStatusIcon} from "../../Products/PublishedProductStatusIcon";
import {getThumbnailUrl} from "./imageUrl";

interface MemberProductsTableProps {
    selectedProducts: Product[];
    quantities: { [key: string]: number };
    handleQuantityChange: (sku: string, value: number) => void;
    onRemove: (product: Product) => void;
    onAssign: () => void;
}

const getProductImageUrl = (product: Product): string | undefined => {
    return getThumbnailUrl(product.coverImage);
};

/**
 * Shared member products table with image, quantity inputs and delete buttons.
 * Used by both ProductBundleCreate and ProductBundleEdit.
 */
export const MemberProductsTable: React.FC<MemberProductsTableProps> = ({
    selectedProducts,
    quantities,
    handleQuantityChange,
    onRemove,
    onAssign,
}) => (
    <Row>
        <Col span={24}>
            <Divider orientation="left">Member Products</Divider>
            <Table dataSource={selectedProducts} rowKey="id" pagination={false}>
                <Table.Column
                    title="Image"
                    key="image"
                    width={80}
                    render={(_, record: Product) => {
                        const url = getProductImageUrl(record);
                        return url ? <Image width={48} height={48} src={url} style={{objectFit: "cover"}} /> : <span style={{color: "#ccc"}}>—</span>;
                    }}
                />
                <Table.Column title="SKU" dataIndex="masterSku" key="masterSku"/>
                <Table.Column title="Name" key="name"
                    render={(_, record: Product) => (
                        <PublishedProductStatusIcon productProp={record}/>
                    )}
                />
                <Table.Column
                    title="Quantity"
                    key="quantityAvailable"
                    render={(_, record: { masterSku: string }) => (
                        <Input
                            type="number"
                            value={quantities[record.masterSku] !== undefined ? quantities[record.masterSku] : 1}
                            onChange={(e) => handleQuantityChange(record.masterSku, Number(e.target.value))}
                        />
                    )}
                />
                <Table.Column title="Delete" dataIndex="delete" key="delete"
                    render={(_, record: Product) => (
                        <DeleteButton size="small" onClick={() => onRemove(record)}/>
                    )}
                />
            </Table>
            <Divider/>
            <Button type="default" onClick={onAssign}>
                Assign Products
            </Button>
        </Col>
    </Row>
);
